import { render, staticRenderFns } from "./sales-apply.vue?vue&type=template&id=705a2b2b&scoped=true&"
import script from "./sales-apply.vue?vue&type=script&lang=js&"
export * from "./sales-apply.vue?vue&type=script&lang=js&"
import style0 from "./sales-apply.vue?vue&type=style&index=0&id=705a2b2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a2b2b",
  null
  
)

export default component.exports